app.apply(app.corePlugins, {
  init: function init(container) {},
  /**
   * The initialisation of the include plugin.
   * Note: This plugin is indended for the prototype only!
   * @public
   * @param {string} container
   */

  initInclude: function initInclude(container) {
    // TODO: Remove this plugin before production.
    $(container).find('[data-include]').each(function () {
      $(this).app_include();
    });
  },
  /**
   * The initialisation of the sticky header plugin.
   * @public
   * @param {string} container
   */

  initStickyHeader: function initStickyHeader(container) {
    $(container).find('[data-header]').each(function () {
      $(this).app_stickyHeader();
    });
  },
  /**
   * The initialisation of the accordion plugin.
   * @public
   * @param {string} container
   */

  initAccordion: function initAccordion(container) {
    $(container).find('[data-accordion]').each(function () {
      $(this).app_accordion();
    });
  },
  /**
   * The initialisation of the tooltips plugin.
   * @public
   * @param {string} container
   */

  initTooltips: function initTooltips(container) {
    $(container).find('[data-tooltip]').each(function () {
      $(this).tooltipster(app.options.tooltips());
      var _this = this;
      $(window).scroll(function () {
        if ($('.tooltipster-show').length) {
          $(_this).tooltipster('hide');
        }
      });
      $(this).on('keydown', function (e) {
        if (e.key == 'Enter' || e.keyCode == '32') {
          e.preventDefault();
          _this.click();
        }
      });
    });
  },
  /**
   * The initialisation of the select2 plugin.
   * @public
   * @param {string} container
   */

  initSelect2: function initSelect2(container) {
    $(container).find('[data-select] select').each(function () {
      $(this).select2(app.options.select());
      $(this).on("select2:open", function () {
        $('.select2-search__field').attr('placeholder', 'search...');
      });
      $(this).on('select2:close', function () {
        $('.select2-search__field').attr('placeholder', null);
      });

      /* Workaround to make select2 508 compliant. */

      $('.select2-selection').removeAttr('role');
      $('.select2-search__field').removeAttr('role');
      $('.select2-search__field').attr('aria-label', 'textbox');
      $('.select2-search__field').attr('type', 'text');
    });
  },
  /**
   * The initialisation of the dropdown plugin.
   * @public
   * @param {string} container
   */

  initDropdown: function initDropdown(container) {
    $(container).find('[data-dropdown]').each(function () {
      $(this).app_dropdown();
    });
  },
  /**
   * The initialisation of smooth scroll elements.
   * @public
   * @param {string} container
   */

  initSmoothScroll: function initSmoothScroll(container) {
    $(container).find('[data-scroll]').each(function () {
      $(this).click(function (e) {
        var str = $.attr(this, 'href');
        var target = str.substring(str.indexOf('#'));
        $('html, body').animate({
          scrollTop: $(target).offset().top
        }, 500);
        e.preventDefault();
      });
    });
  },
  /**
   * The initialisation of the modal plugin.
   * @public
   * @param {string} container
   */

  initModals: function initModals(container) {
    $(container).find('[data-modal]').each(function () {
      $(this).app_modals({
        closeOnBgClick: false
      });
    });
    $(container).find('[data-modal-close]').each(function () {
      $(this).on('click', function () {
        $.magnificPopup.close();
      });
      $(this).on('keydown', function (e) {
        if (e.key == 'Enter' || e.keyCode == 13) {
          $.magnificPopup.close();
        }
      });
    });
  },
  /**
   * The initialisation of the date picker plugin.
   * @public
   * @param {string} container
   */

  initDatepicker: function initDatepicker(container) {
    $(container).find('[data-datepicker] input').each(function () {
      $(this).pickadate(app.options.datepicker());
    });
  },
  /**
   * The initialisation of the cookie policy plugin.
   * @public
   * @param {string} container
   */

  initCookiePolicy: function initCookiePolicy(container) {
    $(container).find('[data-cookie-policy]').each(function () {
      $(this).app_cookiePolicy();
    });
  },
  /**
   * The initialisation of the scroll to top plugin.
   * @public
   * @param {string} container
   */

  initScrollTop: function initScrollTop(container) {
    //$(container).find('[data-scrolltop]').each(function () {
    //    $(this).app_scrollTop();
    //});
  },
  /**
   * The initialisation of the date format plugin.
   * Note: Locks input fields to the date format dd/mm/yyyy.
   * @public
   * @param {string} container
   */

  initDateFormat: function initDateFormat(container) {
    $(container).find('[data-dateformat]').each(function () {
      $(this).on('keyup', function (e) {
        app.helpers.dateFormat(e.target);
      });
    });
  },
  /**
   * The initialisation of the currecy format plugin.
   * Note: To specify a currency use data-currency="$", default is £.
   * @public
   * @param {string} container
   */

  initCurrencyFormat: function initCurrencyFormat(container) {
    $(container).find('[data-currency]').each(function () {
      new AutoNumeric(this, {
        aSign: '£',
        watchExternalChanges: true,
        minimumValue: 0
      });
    });
  },
  /**
   * The initialisation of the currecy format plugin with negative values.
   * Note: To specify a currency use data-currency="$", default is £.
   * @public
   * @param {string} container
   */

  initNegativeCurrencyFormat: function initNegativeCurrencyFormat(container) {
    $(container).find('[data-currency-negative]').each(function () {
      new AutoNumeric(this, {
        aSign: '£',
        watchExternalChanges: true
      });
    });
  },
  /**
   * The initialisation of the range slider plugin.
   * @public
   * @param {string} container
   */

  initRangeSliders: function initRangeSliders(container) {
    $(container).find('[data-slider]').each(function (i) {
      if ($($(this)[i]).hasClass('noUi-target')) {
        $(this)[i].noUiSlider.destroy();
      }
      noUiSlider.create($(this)[i], app.options.slider());
    });
  },
  /**
   * The initialisation of the auto focus plugin.
   * @public
   * @param {string} container
   */

  initAutoFocus: function initAutoFocus(container) {
    $(container).find('[data-focus-group]').each(function () {
      $(this).app_autoFocus();
    });
  },
  /**
   * The initialisation of the device fingerprint plugin.
   * Note: Requires attribute to be placed on an input element.
   * @public
   * @param {string} container
   */

  initDeviceFingerPrint: function initDeviceFingerPrint(container) {
    imprint.test(app.options.deviceImprint()).then(function (result) {
      $(container).find('[data-fingerprint]').each(function () {
        $(this).val(result);
      });
    });
  },
  /**
  * The initialisation of the owl carosel plugin.
  * @public
  * @param {string} container
  */

  initOwlCarosel: function initOwlCarosel(container) {
    $(container).find('.owl-carousel').each(function () {
      $(this).owlCarousel();
    });
  },
  /**
    * The initialisation of the button psinner plugin.
    * @public
    * @param {string} container
    */

  initButtonSpinner: function initButtonSpinner(container) {
    $(container).find('[data-btn-spinner]').each(function () {
      $(this).on('click', function (e) {
        if ($(this).is(':not(:disabled')) $(this).addClass('btn--spinner');
      });
    });
  },
  initReturnSpinner: function initReturnSpinner(container) {
    $(container).find('[data-return]').each(function () {
      $(this).on('click', function (e) {
        if ($(this).is(':not(:disabled')) $(this).addClass('return--spinner');
      });
    });
  },
  initOfferCardPlugins: function initOfferCardPlugins(container) {
    $(container).find('[data-offer]').each(function () {
      $(this).app_offerCard();
    });
    $(container).find('[data-offer-inputcard]').each(function () {
      $(this).app_offerInputCard();
    });
  }
});